<div class="btn-group" dropdown #dropdown="bs-dropdown" [autoClose]="false">
    <!-- <button id="button-basic" dropdownToggle type="button" class="btn btn-group" data-toggle="dropdown" 
    aria-haspopup="true" aria-expanded="true" (click)="changeLanguage()" value="{{lang}}">
        <img class="mr-1" src="assets/img/{{lang}}_flag.png" alt="" width="30px" height="30px" >                                 
    </button>    -->
    <!-- <button *ngIf="this.lang=='my'" id="button-basic" dropdownToggle type="button" class="btn btn-group" data-toggle="dropdown" 
    aria-haspopup="true" aria-expanded="true" (click)="changeLanguage()" value="{{lang}}">
        <img class="mr-1" src="assets/img/my_flag.png" alt="" width="30px" height="30px" >                                 
    </button>   
    
    <button *ngIf="this.lang=='en'" id="button-basic" dropdownToggle type="button" class="btn btn-group" data-toggle="dropdown" 
    aria-haspopup="true" aria-expanded="true" (click)="changeLanguage()" value="{{lang}}">
        <img class="mr-1" src="assets/img/en_flag.png" alt="" width="30px" height="30px" >                                 
    </button>
    <button *ngIf="this.lang=='th'" id="button-basic" dropdownToggle type="button" class="btn btn-group" data-toggle="dropdown" 
    aria-haspopup="true" aria-expanded="true" (click)="changeLanguage()" value="{{lang}}">
        <img class="mr-1" src="assets/img/th_flag.png" alt="" width="30px" height="30px" >                                 
    </button>
    <button *ngIf="this.lang=='zh'" id="button-basic" dropdownToggle type="button" class="btn btn-group" data-toggle="dropdown" 
    aria-haspopup="true" aria-expanded="true" (click)="changeLanguage()" value="{{lang}}">
        <img class="mr-1" src="assets/img/zh_flag.png" alt="" width="30px" height="30px" >                                 
    </button> -->

   <div class="dropdown" [class.show]="isDropdownOpen">
  <button
    id="button-basic"
    type="button"
    class="btn btn-group"
    (click)="toggleDropdown()"
  >
    <img
      class="mr-1"
      *ngIf="lang"
      [src]="'assets/img/' + lang + '_flag.png'"
      alt=""
      width="30px"
      height="30px"
    >
  </button>

  <ul
    *ngIf="isDropdownOpen"
    class="dropdown-menu dropdown-menu-right show"
    role="menu"
  >
    <a
      class="dropdown-item d-flex align-items-center"
      *ngFor="let language of supportLanguages; let i = index"
      [class.active]="selectedIndex == i"
      (click)="selectedLanguageCountry(language, i)"
      style="height: 35px;"
    >
      <img
        class="mr-1"
        [src]="'assets/img/' + language + '_flag.png'"
        alt=""
        width="25"
        height="25"
      >
      <span *ngIf="language == 'en'">English</span>
      <span *ngIf="language == 'my'">မြန်မာ</span>
      <span *ngIf="language == 'th'">ประเทศไทย</span>
      <span *ngIf="language == 'zh'">中文</span>
    </a>
  </ul>
</div>

</div>  